import * as React from 'react';
import Collapse from 'antd/lib/collapse';
import Text from 'antd/lib/typography/Text';
import RightOutlined from '@ant-design/icons/RightOutlined';

import VCSDirectPushCheck from './VCSDirectPushCheck';
import { antGrey } from '../styles/globalStyles';

interface Props {
    orgId: string;
    appId: string;
    branch: string | null;
    description: string;
    muted?: boolean;
    disabledReason?: string;
}

export default function BranchCreationCheck({
    orgId,
    appId,
    branch,
    description,
    muted = false,
    disabledReason,
}: Props): JSX.Element {
    return (
        <Collapse
            ghost
            className="collapse-no-padding"
            // Antd's own arrow, recoloured so it doesn't outweigh muted text
            expandIcon={({ isActive }) => (
                <RightOutlined rotate={isActive ? 90 : 0} style={muted ? { color: antGrey.grey7 } : undefined} />
            )}
            items={[
                {
                    key: 'branchCreationCheck',
                    className: 'collapse-panel-no-padding',
                    label: <Text type={muted ? 'secondary' : undefined}>{description}</Text>,
                    children: (
                        <div style={{ paddingTop: 8 }}>
                            <VCSDirectPushCheck
                                orgId={orgId}
                                appId={appId}
                                operation="createBranch"
                                branch={branch}
                                disabledReason={disabledReason}
                            />
                        </div>
                    ),
                },
            ]}
        />
    );
}
